<div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
  <div class="line-break"></div>
</div>
<div class="col-12 col-sm-12 col-md-12 col-lg-12" *ngIf="hasValidationErrors">
  <span
    ><label class="fw-bold">Errors</label>
    <span class="download-report" (click)="downloadPDFErrorReport()">
      <i class="fa fa-download download-report-icon" id="download-error-report-icon"></i>
      <a class="download-full-error-report-link" id="download-full-error-report"
        >Download Full Report(PDF)</a
      >
    </span>
  </span>
</div>
<div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 mt-20">
  <ul class="list-group">
    <li
      class="list-group-item analyzer-error-item"
      id="error-item"
      *ngFor="let genericErrorMsgItem of genericErrorMesasgesList; trackBy: trackByIdentity"
    >
      <span
        ><i
          class="fa fa-exclamation-circle"
          style="color: #ea4b50 !important; width: 20px"
          id="exclamation-error-icon"
        ></i
      ></span>
      {{ genericErrorMsgItem }}
    </li>
  </ul>
</div>
